import { render, staticRenderFns } from "./QuienesSomos.vue?vue&type=template&id=38053597&"
import script from "./QuienesSomos.vue?vue&type=script&lang=js&"
export * from "./QuienesSomos.vue?vue&type=script&lang=js&"
import style0 from "./QuienesSomos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports